export enum ClaimTypesEnum {
  OP = 'OP',
  HOSP = 'HOSP',
  MAT = 'MAT',
  DEN = 'DEN',
}
